import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorIcon from 'app/icons/error_illustration.svg';
import FloatingRectangles from 'app/components/FloatingRectangles';
import { useWidgetDisplayMetrics } from 'app/hooks/useWidgetDisplayMetrics';
import DisplayContext from 'app/common/DisplayContext';

import style from './style.module.scss';

interface Props {
  type?: BlockErrorType;
  sendWidgetDisplayMetrics?: boolean;
  floatingRectanglesClassName?: string;
}

const Error: FC<Props> = ({
  type = 'undetermined',
  sendWidgetDisplayMetrics,
  floatingRectanglesClassName
}) => {
  const { t } = useTranslation();
  const displayState = useContext(DisplayContext);

  useWidgetDisplayMetrics(
    undefined,
    sendWidgetDisplayMetrics ? 'INTEGRATION_ERROR' : undefined,
    undefined,
    displayState
  );

  return (
    <FloatingRectangles className={floatingRectanglesClassName}>
      <ErrorIcon className={style.errorIcon} />
      <div className={style.errorMessage}>
        <p>{t(`error_${type}_line-1`)}</p>
        {(type === 'undetermined' || type === 'no-stream') && <p>{t(`error_${type}_line-2`)}</p>}
      </div>
    </FloatingRectangles>
  );
};

Error.displayName = 'Error';

export default Error;
